// extracted by mini-css-extract-plugin
export default {"textContainer":"Info_textContainer__g5YNS"};